import React from 'react';

import websitePage from 'hoc/websitePage/websitePage';
import OldPageSectionHeading from 'components/structure/OldPageSectionHeading';

import SectionEthicsVideo from './patterns/SectionEthicsVideo/SectionEthicsVideo';

export function EthicAndCompliance() {
  return (
    <>
      <OldPageSectionHeading intlKey="ETHICS.TITLE" />
      <SectionEthicsVideo />
    </>
  );
}

export default websitePage({
  routeKey: 'ETHICS',
})(EthicAndCompliance);
